import React, { FC, Fragment, ReactNode } from 'react';

import { GetPostedToGroupsComponent, PostedToGroup } from 'api';

interface IProps {
  children: (postedToGroups: PostedToGroup[]) => ReactNode;
}

const GetPostedToGroups: FC<IProps> = ({ children }) => {
  const queryKey = 'contextGetPostedToGroups';

  return (
    <GetPostedToGroupsComponent>
      {queryResult => {
        const { data, loading } = queryResult;
        if (loading) {
          return <Fragment>{children([])}</Fragment>;
        }

        if (!data || !data[queryKey]) {
          return null;
        }

        return <Fragment>{children(data[queryKey])}</Fragment>;
      }}
    </GetPostedToGroupsComponent>
  );
};

export default GetPostedToGroups;
